import PropTypes from 'prop-types'

export default {
    entry_point: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    file: PropTypes.arrayOf(PropTypes.shape({})),
    file_size: PropTypes.number,
    md5: PropTypes.string,
    length: PropTypes.number,
    date_start: PropTypes.number,
    date_end: PropTypes.number,
}
